import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DataService } from 'src/app/shared/services/data.service';
import { TranslateService } from '@devinforius/i-essentials';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfigDto } from 'src/app/shared/interfaces/config';
import { environment } from 'src/environments/environment';
import { LOCAL_RELEASE_NOTES } from 'src/app/shared/models/assistance/local-release-notes';

@Component({
  selector: 'app-assistance',
  templateUrl: './assistance.component.html',
  styleUrls: ['./assistance.component.scss'],
})
export class AssistanceComponent implements OnInit {
  public AssistanceText = `Répondre à vos questions est la priorité de notre équipe Assistance.`;
  public config: ConfigDto = null;
  public actualVersion: string;
  public clientType = sessionStorage.getItem('clientType');

  public versionsList: string[] = Object.keys(LOCAL_RELEASE_NOTES);

  /**
   * User guide PDFs shipped locally with the app (assets/user-guides/<file>). Add an entry here for each
   * guide provided.
   */
  public userGuides: { description: string; url: string }[] = [
    { description: 'Guide utilisateur', url: 'assets/user-guides/Guide_utilisateur-iCourrier.pdf' },
    { description: 'Guide encodeur', url: 'assets/user-guides/Guide_encodeur-iCourrier.pdf' },
  ];

  public openUserGuideModal = false;
  public modalHeaderUserGuide = {
    title: 'assistance.userGuide',
    showNotification: false,
    showParameters: false,
    closable: true,
  };
  public modalParamsUserGuide = {
    isDraggable: false,
    isResizable: true,
    isModal: true,
    style: { height: '80vh', width: '70vw', minWidth: '50vw', maxWidth: '70vw' },
  };

  constructor(
    private titleService: Title,
    public dataService: DataService,
    private translater: TranslateService,
    private configService: ConfigService
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.translater.translate('tabsTitle.help'));
    this.modalHeaderUserGuide.title = this.translater.translate(this.modalHeaderUserGuide.title);
    this.configService.fetchConfig().subscribe({
      next: (res) => {
        this.getData(res);
      },
    });
    this.dataService.getversiongApp.subscribe({
      next: (res) => {
        this.actualVersion = res;
      },
    });
  }

  getData(config: ConfigDto): void {
    this.config = config;
    this.config.phone = this.config && this.config.phone ? this.config.phone : '081/744 340';
    this.config.email = this.config && this.config.email ? this.config.email : 'infodoc@inforius.be';
  }

  public openVersionInfos(version: string): void {
    window.open(LOCAL_RELEASE_NOTES[version], '_blank');
  }

  public save(item: { description: string; url: string }): void {
    window.open(item.url, '_blank');
  }

  public delegationAcces(): void {
    const config = environment;

    window.location.href = `${config.issuer}/Support/DelegationRequests?clientid=${config.clientId
      }&clientUri=${encodeURIComponent(config.postLogoutRedirectUri)}`;
  }
}
